// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gk9V","controls":"styles_controls__c7v5S","charLimit":"styles_charLimit__3kRMC","input":"styles_input__RWh9T","send":"styles_send__3f9FM"};